<template>
    <div>
        <h2 class="text-sm font-medium text-gray-700 mb-1">Collection</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <table class="w-full table-fixed mb-8">
                <tbody>
                    <tr>
                        <td class="text-gray-600 text-sm">Default Markup</td>
                        <td class="text-right pl-4 text-sm font-medium">
                            <div class="flex">
                                <input type="text" v-model="estimate.default_markup_pc" @change="recalculateAndSave" class="flex-1 text-sm m-0 px-2 py-0.5 bg-gray-50 font-medium text-gray-700 text-right border-gray-300 rounded-l shadow-none focus:z-20" :disabled="estimate.cannot_be_edited_by_authed_user">
                                <div class="flex-shrink-0 -ml-px text-sm text-gray-500 px-1 py-0.5 rounded-r bg-gray-100 border border-gray-300">%</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-gray-600 text-sm">MCD</td>
                        <td class="text-right pl-4 text-sm font-medium">
                            <div class="flex">
                                <input type="text" v-model="estimate.mcd_pc" @change="recalculateAndSave" class="flex-1 text-sm m-0 px-2 py-0.5 bg-gray-50 font-medium text-gray-700 text-right border-gray-300 rounded-l shadow-none focus:z-20" :disabled="estimate.cannot_be_edited_by_authed_user">
                                <div class="flex-shrink-0 -ml-px text-sm text-gray-500 px-1 py-0.5 rounded-r bg-gray-100 border border-gray-300">%</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-gray-600 text-sm">Retention</td>
                        <td class="text-right pl-4 text-sm font-medium">
                            <div class="flex">
                                <input type="text" v-model="estimate.retention_pc" @change="recalculateAndSave" class="flex-1 text-sm m-0 px-2 py-0.5 bg-gray-50 font-medium text-gray-700 text-right border-gray-300 rounded-l shadow-none focus:z-20" :disabled="estimate.cannot_be_edited_by_authed_user">
                                <div class="flex-shrink-0 -ml-px text-sm text-gray-500 px-1 py-0.5 rounded-r bg-gray-100 border border-gray-300">%</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="w-full table-fixed">
                <tbody>
                    <tr v-for="section in nonOptionalSections" :key="section.key">
                        <td class="text-gray-600 text-sm">{{ section.title }}</td>
                        <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                            <div class="flex items-center justify-between">
                                <div>£</div>
                                <div>{{ section.amount | toCurrency(false) }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-gray-600 text-sm">Sections Total</td>
                        <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                            <div class="flex items-center justify-between">
                                <div>£</div>
                                <div>{{ estimate.amount | toCurrency(false) }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <div class="border-t border-gray-200 my-3"></div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-gray-600 text-sm">Markup</td>
                        <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                            <div class="flex items-center justify-between">
                                <div>£</div>
                                <div>{{ estimate.markup_amount | toCurrency(false) }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-gray-600 text-sm"></td>
                        <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">({{ estimate.markup_pc }}%)</td>
                    </tr>
                    <tr>
                        <td class="text-gray-600 text-sm">Sub Total</td>
                        <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                            <div class="flex items-center justify-between">
                                <div>£</div>
                                <div>{{ estimate.cf_amount | toCurrency(false) }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <div class="border-t border-gray-200 my-3"></div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-gray-600 text-sm">MCD</td>
                        <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                            <div class="flex items-center justify-between">
                                <div>£</div>
                                <div>{{ - estimate.mcd | toCurrency(false) }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-gray-600 text-sm">Total</td>
                        <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                            <div class="flex items-center justify-between">
                                <div>£</div>
                                <div>{{ estimate.total | toCurrency(false) }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-gray-600 text-sm">Retention</td>
                        <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                            <div class="flex items-center justify-between">
                                <div>£</div>
                                <div>{{ estimate.retention | toCurrency(false) }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="optionalSections.length > 0">
                        <td colspan="2" class="pt-3">
                            <div class="relative">
                                <div class="border-t border-gray-200 my-3"></div>
                                <div class="absolute inset-0 flex items-center justify-center">
                                    <div class="text-xs px-2 py-1 bg-gray-50 text-gray-400 font-semibold">
                                        options
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="section in optionalSections" :key="section.key">
                        <td class="text-gray-600 text-sm">{{ section.title }}</td>
                        <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                            <div class="flex items-center justify-between">
                                <div>£</div>
                                <div>{{ section.cf_amount | toCurrency(false) }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="optionalSections.length > 0">
                        <td colspan="2">
                            <div class="pt-3 text-xs bg-gray-50 text-gray-400 italic">
                                Options are displayed after markup and excluded from the total above.
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { estimateStore } from '@stores'

export default {
    computed: {
        $store () {
            return estimateStore
        },
        estimate () {
            return this.$store.state.estimate
        },
        nonOptionalSections () {
            return this.estimate.sections.filter(section => ! section.optional)
        },
        optionalSections () {
            return this.estimate.sections.filter(section => section.optional)
        },
    },
    methods: {
        recalculateAndSave () {
            if (this.estimate.cannot_be_edited_by_authed_user) return
            this.$store.recalculateTotals()
            this.$store.save()
        },
    },
}
</script>
